// wordCloudData.js
// Word -> SVG mapping for the Safe activity, ported from room.php's own
// inline script: each word's `<g id="...">` is the one clickable instance;
// clicking it repaints every element sharing its `cssClass` (the decorative
// repeats scattered through the cloud share the class but not the id — see
// $(className).css({fill:'green'}) in room.php).
export const SAFE_WORDS = [
  { id: 'Hydrate', label: 'Hydrate', cssClass: 'cls-6' },
  { id: 'Stay_Active', label: 'Stay Active', cssClass: 'cls-4' },
  { id: 'Read_Regularly', label: 'Read Regularly', cssClass: 'cls-5' },
  { id: 'Prioritize_Sleep', label: 'Prioritize Sleep', cssClass: 'cls-3' },
  { id: 'Practice_Gratitude', label: 'Practice Gratitude', cssClass: 'cls-2' },
  { id: 'Sustainable_Living', label: 'Sustainable Living', cssClass: 'cls-1' },
];

// room.php only reveals/enables the Submit button once countclick >= 3
// (toggleSubmitButton()) — not all 6, confirmed from the JS.
export const SAFE_MIN_WORDS_FOR_SUBMIT = 3;
